/** The `contacts` area: the account page's contacts section. Owned by the stage
 *  2 slot components-b (docs/I18N.md §11). */
export const contacts = {
  'contacts.add.placeholder': 'handle or name@example.com',
  'contacts.add.label': 'Add a contact by handle or address',
  'contacts.add.send': 'Send',
  /** Says what happened on this side only, whatever the text found. */
  'contacts.add.sent': 'Request sent to {identifier}.',
  'contacts.empty': 'No contacts yet. Adding one lets you seat and share with each other.',
  'contacts.requests': 'Requests',
  'contacts.groupInvitations': 'Group invitations',
  'contacts.contacts': 'Contacts',
  'contacts.sent': 'Sent',
  'contacts.blocked': 'Blocked',
  'contacts.accept': 'Accept',
  'contacts.decline': 'Decline',
  'contacts.withdrawn': 'withdrawn',
  /** `group`: the group's name, in its own span. */
  'contacts.addedYou': '{adder} added you to {group}',
  'contacts.youWereAdded': 'You were added to {group}',
  /** `date`: when an unanswered request expires. */
  'contacts.until': 'until {date}',
  'contacts.withdraw': 'Withdraw',
  'contacts.unblock': 'Unblock',
  'contacts.remove': 'Remove contact',
  'contacts.options': 'Options for {name}',
  'contacts.block': 'Block',
  'contacts.block.withdrawn': 'No request passes either way until you unblock.',
  'contacts.block.request':
    'Declines this request. No request passes either way until you unblock.',
  'contacts.block.invitations':
    'Hides their invitations. No request passes either way until you unblock.',
  'contacts.block.contact': 'Removes the contact. No request passes either way until you unblock.',
  /** What is wrong with what was typed to reach someone (domain/reach.ts). */
  'contacts.reach.empty': 'A handle or an address is needed.',
  'contacts.reach.notAddress': 'That is not an address.',
  'contacts.reach.notHandle': 'That is not a handle or an address.',
} as const;
